import type { RouterRootContext } from '@/router'
import { checkAuthRoleBeforeLoad } from '@/components/beforeLoad'
import { GlobalErrorPage } from '@/components/ui/errors'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/editor/')({
  component: Outlet,
  errorComponent: GlobalErrorPage,
  beforeLoad: ctx => checkAuthRoleBeforeLoad(ctx.context as RouterRootContext, 'editor'),
})
